import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function GetBuildInfo() {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      clientId: "100",
    },
    url: `${BASE_URL}/api/config/version`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
